import { css } from 'styled-components';

import type { ITypography, TNavigationTypes } from '../types';

const Navigation = css<ITypography>`
  letter-spacing: ${({ theme, variant }) => theme.typography.variants[variant as TNavigationTypes].letterSpacing};

  ${({ theme }) => theme.screenSize.s1024.mediaQuery} {
    font-size: ${({ theme, variant }) => theme.typography.variants[variant as TNavigationTypes].desktopFontSize};
  }
`;

export default Navigation;
